import { render } from "./DrawerNavigation.vue?vue&type=template&id=3fc24181"
import script from "./DrawerNavigation.vue?vue&type=script&lang=js"
export * from "./DrawerNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__